import styles from "./Technology.module.scss";
import TechCard from "./TechCard";
import androidImg from "../../assets/technologies/android.svg";
import flutterImg from "../../assets/technologies/flutter.svg";
import cloudImg from "../../assets/technologies/cloud.svg";
import figmaImg from "../../assets/technologies/figma.svg";
import webImg from "../../assets/technologies/web.png";
import { android, flutter, cloud, ui, web } from "./Content";
import { useColorModeValue } from "../../hooks/useColorModeValue";
import { motion } from "framer-motion";

function Technology() {
  return (
    <div className={styles["technology"]}>
      <div className={styles[useColorModeValue("titleLight", "titleDark")]}>
        <span></span>
        <p>TECHNOLOGIES</p>
        <span></span>
      </div>
      <div className={styles[useColorModeValue("tagLineLight", "tagLineDark")]}>
        Domains That Excite Us to Collaborate and Teach!
      </div>
      <div style={{ overflow: "hidden", cursor: "grab" }}>
        <motion.div className={styles["cards"]} drag="x" dragSnapToOrigin dragElastic="4">
          <TechCard image={webImg} fill="#f1bf26" title="Web Development" data={web} />
          <TechCard image={androidImg} fill="#EA4335" title="Android" data={android} />
          <TechCard image={figmaImg} fill="#a259ff" title="UI/UX" data={ui} />
          <TechCard image={cloudImg} fill="#34A853" title="Cloud" data={cloud} />
          <TechCard image={flutterImg} fill="#4285F4" title="Flutter" data={flutter} />
        </motion.div>
      </div>
    </div>
  );
}

export default Technology;
